import {NgModule} from '@angular/core';
import {ExtraOptions, RouterModule, Routes} from '@angular/router';
import {AppLayoutComponent} from './layout/app.layout.component';
import {AuthGuard} from "./guards/auth.guard";

import {AdminComponent} from "./admin/admin.component";
import {SipoComponent} from "./sipo/sipo.component";
import {DragDropScrollComponent} from "./sipo/document-viewer/drag-drop-scroll.component";
import {SignComponent} from "./sipo/sign/sign.component";
import {SplittedPageComponent} from "./sipo/splitted-page/splitted-page.component";
import {TaskComponent} from "./task/task.component";
import {CscComponent} from "./sipo/csc/csc.component";
import {CallbackComponent} from "./sipo/csc/callback/callback.component";
import {
    DocumentSigningComponent
} from "./sipo/document-signing/document-signing.component";
import {PaymentComponent} from "./sipo/payment/payment.component";
import {CanDeactivateGuard} from "./guards/can-deactivate.guard";
import {PayComponent} from "./sipo/payment/pay/pay.component";
import {WebComponent} from "./web/web.component";
// import {WebComponent} from "./web/web.component";

const routerOptions: ExtraOptions = {
    anchorScrolling: 'enabled'
};


let routes: Routes = [
    {
        path: '',
        component: AppLayoutComponent,
        children: [
            {
                path: '',
                component: SipoComponent,
                canActivate: [AuthGuard],
                data: {breadcrumb: 'Sipo'},
            },
            {
                path: 'stripe',
                component: PayComponent,
                canActivate: [],
                data: {breadcrumb: 'Checkout'},
            }, {
                path: 'web',
                component: WebComponent,
                canActivate: [AuthGuard],
                data: {breadcrumb: 'Web'},
            },
            {
                path: 'home',
                component: SplittedPageComponent,
                canActivate: [AuthGuard],
                data: {breadcrumb: 'Sipo'},
            },
            {
                path: 'sipo',
                component: SipoComponent,
                canActivate: [AuthGuard],
                data: {breadcrumb: 'Sipo'},
            },
            {
                path: 'payment',
                component: PaymentComponent,
                canActivate: [AuthGuard],
                canDeactivate: [CanDeactivateGuard],
                data: {breadcrumb: 'Payment'},
            },
            {
                path: 'task',
                component: TaskComponent,
                canActivate: [AuthGuard],
                data: {breadcrumb: 'Task'},
            },
            {
                path: 'sign',
                component: SignComponent,
                canActivate: [AuthGuard],
                data: {breadcrumb: 'Sign'},
            },
            {
                path: 'csccallback',
                component: CallbackComponent,
                data: {breadcrumb: 'CSC'},
            },


            {
                path: 'csc',
                component: CscComponent,
                canActivate: [AuthGuard],
                data: {breadcrumb: 'CSC'},
            },
            {
                path: `signing/:processid/:sitemid`,
                component: DocumentSigningComponent,
                canActivate: [],
                data: {breadcrumb: 'Document signing'},
            },
            {
                path: 'viewer',
                component: DragDropScrollComponent,
                canActivate: [AuthGuard],
                data: {breadcrumb: 'Sipo'},
            },
            {
                path: 'admin',
                component: AdminComponent,
                data: {breadcrumb: 'Preferences'},
            },
            {
                path: '',
                loadChildren: () => import('./dashboards/dashboards.module').then(m => m.DashboardsModule),
                canActivate: [AuthGuard],
            },
        ],
    },

    {
        path: 'notfound',
        loadChildren: () => import('./components/notfound/notfound.module').then((m) => m.NotfoundModule),
    },
    {
        path: '**',
        redirectTo: '/notfound',
    },
];


@NgModule({
    imports: [RouterModule.forRoot(routes, routerOptions)],
    exports: [RouterModule]
})
export class AppRoutingModule {
}
